module.exports = __webpack_public_path__ + "static/media/IMG_1820.96c6b126.JPG";